module.exports = new __parcel__URL__("cant-replace.cf1c0449.mp3").toString();